import PropTypes from 'prop-types';
import classes from './Button.module.css';

const Button = ({ onClick, children, backgroundColor, color }) => (
  <button
    className={classes.button}
    onClick={onClick}
    type="button"
    style={{ backgroundColor, color }}
  >
    <p className={classes.label}>{children}</p>
  </button>
);

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  backgroundColor: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default Button;
